var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { staticClass: "contactum-label" }, [
        _vm._v(" " + _vm._s(_vm.field.title) + " test ")
      ]),
      _vm._v(" "),
      _c("wp_editor", {
        attrs: { value: _vm.value },
        on: { "content-changed": _vm.onEditorContentChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }